import { useEffect, useState } from 'react';
import { Button, Col, Form, message, Result, Space } from 'antd';
import 'moment-timezone'
import { TextService } from '../../Services/TextService';
import { useAuth } from '../../Contexts/AuthContext';
import { BookyInput } from '../../Components/Forms/BookyInput';
import { CompanyService } from '../../Services/CompanyService';
import { IntegrationService } from '../../Services/IntegrationService';
import { IntegrationType } from '../../Types/IntegrationType';
import LeftMenuSettings from './LeftSettings';
import LayoutLeftMenu from '../../Components/Layout/LayoutLeftMenu';
import { BookyButton } from '../../Components/Buttons/BookyButton';
import { isOnlyNumbers } from '../../Helpers/Validators';

const CreatePingPaymentIntegration = () => {
    const [event, setEvent] = useState([] as any);
    const [language, setLanguage] = useState("" as string);
    const [showSuccess, setShowSuccess] = useState(false as boolean);
    const [isLoading, setIsLoading] = useState(false as boolean);

    const [form] = Form.useForm();
    const { user } = useAuth();

    const GetText = TextService.GetText;

    const FormCreateClick = async (values: any) => {



        if (
            values.userIdentity.length !== 12 ||
            !isOnlyNumbers(values.userIdentity)
        ) {
            message.error(GetText("CreatePingPayment_IdentityNumberError"));
            return;
        }


        try {
            setIsLoading(true);
            await IntegrationService.ConnectIntegration({
                integrationType: IntegrationType.PingPayments,
                accessCode: ""
            });

            await IntegrationService.CreateAndPublishPingPaymentAgreement({
                identity: values.userIdentity,
                name: values.userName,
                email: values.userEmail,
                phoneNumber: values.userPhone,
            });
            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
            message.warning(GetText("Common_TempError"));
            return;
        }

        setIsLoading(false);
        setShowSuccess(true)
    };

    const handleChange = (value: string) => {
        setLanguage(value);
    };

    useEffect(() => {
        CompanyService.GetCompany().then(company => {
            handleChange(company.language!);
            form.setFieldValue("companyorgnumber", company.organisationNumber!);
            form.setFieldValue("userName", user?.firstName + " " + user?.lastName!);
            form.setFieldValue("userEmail", user?.email!);
        });
    }, [user]);


    return <LayoutLeftMenu fullpageMain={true} title={GetText("Settings_Account")} menu={<LeftMenuSettings selected={"integrations"} />}>
        <Col span={16}>
            <Col className='bookyBox' style={{ marginLeft: "20px" }}>
                <Space style={{ width: '100%', justifyContent: 'left', margin: 0 }}>
                    <h3>{GetText("CreatePingPayment_Title")}</h3>
                </Space>

                {showSuccess ? <Result
                    status="success"
                    title={GetText("CreatePingPayment_AgreementCreated")}
                    subTitle={GetText("CreatePingPayment_AgreementCreatedDescription")}
                /> :
                    <>
                        <Space style={{ width: '100%', maxWidth: "700px", justifyContent: 'left', margin: 0 }}>
                            <p>{GetText("CreatePingPayment_Description")}</p>
                        </Space>
                        < Form
                            colon={false}
                            form={form}
                            labelCol={{
                                span: 3,
                            }}
                            onFinish={FormCreateClick}
                            wrapperCol={{
                                span: 6,
                            }}
                            layout="vertical"
                        >
                            <BookyInput label={GetText("CreatePingPayment_IdentityNumber")} placeholder="YYYYMMDDXXXX" name="userIdentity" req></BookyInput>
                            <BookyInput label={GetText("CreatePingPayment_Name")} name="userName" req></BookyInput>
                            <BookyInput label={GetText("CreatePingPayment_Email")} name="userEmail" req></BookyInput>
                            <BookyInput label={GetText("CreatePingPayment_PhoneNumber")} name="userPhone" req></BookyInput>


                            <Form.Item label={" "}>
                                <BookyButton fullWidth loading={isLoading} style={{ marginTop: "10px" }} htmlType="submit" text={GetText("CreatePingPayment_Save")}></BookyButton>
                            </Form.Item>
                        </Form>
                    </>
                }
            </Col>
        </Col>
    </LayoutLeftMenu >

};

export default CreatePingPaymentIntegration;